import script from "./loaderPromoPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./loaderPromoPopup.vue?vue&type=script&lang=ts&setup=true"

import "./loaderPromoPopup.vue?vue&type=style&index=0&id=405e3fd2&scoped=true&lang=scss"

import exportComponent from "/home/sergiy/projects/magnetics/promo.land/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405e3fd2"]])

export default __exports__